import * as React from 'react';

import iconUrl from './BottomArrowIcon.svg';

export const BottomArrowIcon = <img width="10" height="10" src={iconUrl} alt="" />;
